/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const OtherAccount = zod.strictObject({
    id: zod.number(),
    name: zod.string(),
});

export type OtherAccount = zod.input<typeof OtherAccount>;
export type OtherAccountOutput = zod.output<typeof OtherAccount>;
